define(['jquery', 'forms', 'pricehelper'], function ($, Forms, ERVPriceHelper) {
	var TechEquip = function() {
		var self = this;

		self.forms = new Forms();
		self.$ervBody = $('#erv-body');
		self.$form = $('.techequippage form[data-js-mainform]');
		self.priceHelper = new ERVPriceHelper();
		self.$summaryInsuredTotal = self.$ervBody.find('.summary-insuredtotal');
		self.$summaryPremie = self.$ervBody.find('.summary-premie');
		self.$summaryTax = self.$ervBody.find('.summary-tax');
		self.$summaryTotal = self.$ervBody.find('.summary-totalprice');

		self.deleteEquipment = function($equip) {
			var deletedIndex = $equip.data('id');
			$equip.remove();
			self.refreshEquipment(deletedIndex);
			self.refreshPrice();
			return deletedIndex;
		};

		self.getTotalInsuredPrice = function () {
			var $valueContainer = self.$ervBody.find('input:text[data-pricecalctrigger]');
			var value = 0;

			$valueContainer.each(function () {
				try {
					value += Number($(this).val());
				} catch (e) {
				}
			});

			return value;
		}
		
		self.refreshPrice = function() {
			var $dataHolder = self.$ervBody.find('.equipment-summary'),
				totalInsuredPrice = self.getTotalInsuredPrice(),
				totalCostFactor = Number($dataHolder.data('selectedpaymenttype') + Number($dataHolder.data('selectedpremieaddon'))),
				tax = Number($dataHolder.data('tax')),
				premie =  $dataHolder.data('premie'),
				totalPremie = totalInsuredPrice * totalCostFactor;

			if (totalInsuredPrice === 0 && self.$summaryInsuredTotal.text() === '0,00') {
				return;
			}

			if (totalInsuredPrice === 0) {
				self.$summaryPremie.text(self.priceHelper.formatPrice(0));
				self.$summaryInsuredTotal.text(self.priceHelper.formatPrice(0));
				self.$summaryTax.text(self.priceHelper.formatPrice(0));
				self.$summaryTotal.text(self.priceHelper.formatPrice(0));
				return;
			}

			totalPremie = totalPremie * Number($dataHolder.data('selectedpremiecover'));

			if (totalPremie > premie) {
				self.$summaryPremie.text(self.priceHelper.formatPrice(totalPremie));
			} else {
				totalPremie = premie;
				self.$summaryPremie.text(self.priceHelper.formatPrice(premie));
			}

			var totalTax = totalPremie * tax,
				totalCost = totalTax + totalPremie;

			self.$summaryInsuredTotal.text(self.priceHelper.formatPrice(totalInsuredPrice));

			self.$summaryTax.text(self.priceHelper.formatPrice(totalTax));

			self.$summaryTotal.text(self.priceHelper.formatPrice(totalCost));
		}

		self.initPrice = function () {
			var $dataHolder = self.$ervBody.find('.equipment-summary');

			$dataHolder.data('selectedpaymenttype', Number($('input:radio[data-paymenttype]:checked').data('paymenttype')));
			$dataHolder.data('selectedpremiecover', Number($('input:radio[data-premiecover]:checked').data('premiecover')));
			$dataHolder.data('selectedpremieaddon', Number($('input:radio[data-premieaddon]:checked').data('premieaddon')));
			$dataHolder.data('premie', 1000);

			self.refreshPrice();
		}

		self.refreshEquipment = function (deletedIndex) {
			var $allAdded = self.$equipList.find('.equipment.added');
			var $allNext = $allAdded.filter(function () {
				return ($(this).data('id') > deletedIndex); 
			});

			$allNext.each(function () {
				var $equip = $(this);
				var index = $equip.data('id'),
					newIndex = (index - 1);

				$equip.find('.index').text(index);
				$equip.data('id', newIndex);

				$equip.find('input[type=text], input[data-inputtype="text"]').each(function () {
					var $input = $(this);
					$input.attr('name', $input.attr('name').replace(index, newIndex));
					$input.attr('id', $input.attr('id').replace(index, newIndex));
				});

				$equip.find('label').each(function () {
					var $label = $(this);
					$label.attr('for', $label.attr('for').replace(index, newIndex));
				});
			});
		};
		
		self.addEquipment = function () {
			var currentIndex = self.$equipList.find('.added').length,
				html = self.$equipTemplate.html().replace(/{{index}}/g, currentIndex);

			var $html = $(html);
			$html.find('.index').text(currentIndex + 1);
			$html.insertBefore($(self.$equipList.find('li').last()));

			var $input = $html.find('input[id$="Sum"]');

			$input.rules('add',
			{
				required: true
			});

			$input.on('blur', function () {
				$(this).valid();
			});

			$html.find('[data-pricecalctrigger]').on('keyup', function () {
				self.$ervBody.find('[data-totalinsuredprice]').data('totalinsuredprice', self.getTotalInsuredPrice());
				self.refreshPrice();
			});
		};

		self.setupEventHandling = function() {
			self.$equipTemplate = self.$ervBody.find('#equipment-template');
			self.$equipList = self.$form.find('.equipment-list ul');
			
			self.$form.find('#add-equipment').on('click', function (e) {
				e.preventDefault();
				self.addEquipment();
			});

			self.$equipList.on('click', '.equipment.added .remove-equipment', function (e) {
				e.preventDefault();
				self.deleteEquipment($(this).parents('.equipment.added'));
			});

			self.$ervBody.find('[data-pricecalctrigger]').each(function() {
				var $trigger = $(this),
					whatToUpdate = $trigger.data('pricecalctrigger'),
					value = $trigger.data(whatToUpdate);

				$trigger.on('change', function() {
					var $valueContainer = self.$ervBody.find('[data-selected' + whatToUpdate + ']');
					$valueContainer.data('selected' + whatToUpdate, value);
					self.refreshPrice();
				});

				$trigger.on('keyup', function () {
					self.$ervBody.find('[data-totalinsuredprice]').data('totalinsuredprice', self.getTotalInsuredPrice());
					self.refreshPrice();
				});
			});
		};
	};

	TechEquip.prototype.init = function () {
		var self = this;
		self.setupEventHandling();

		self.initPrice();

		var $button = self.$ervBody.find('.next-step');
		$button.on('click', function (e) {
			if (!$button.parents('form').valid()) {
				e.preventDefault();
				e.stopPropagation();
			}
		});
	}

	return TechEquip;
});